export const SET_DATA_FIELD = 'SET_DATA_FIELD';

export function setDataField(key, value) {
    return { type: SET_DATA_FIELD, key, value };
}
